import { Injectable } from '@angular/core'
import { NumberPublisher } from '@app/domain/NumberPublisher'
import { RequestedBookingsCountPublisher } from '@app/domain/RequestedBookingsCountPublisher'
import { MessagesUnreadCountPublisher } from '@app/domain/MessagesUnreadCountPublisher'
import { combineLatest, map } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class InboxNotificationCountPublisher implements NumberPublisher {

    number$ = combineLatest([
        this.requestedBookingsCountPublisher.number$,
        this.messagesUnreadCountPublisher.number$,
    ]).pipe(
        map(([requestedCount, unreadMessagesCount]) => requestedCount + unreadMessagesCount)
    )

    constructor(
        private requestedBookingsCountPublisher: RequestedBookingsCountPublisher,
        private messagesUnreadCountPublisher: MessagesUnreadCountPublisher,
    ) { }

    refreshNow() {
        this.requestedBookingsCountPublisher.refreshNow()
        this.messagesUnreadCountPublisher.refreshNow()
    }
}
